import React, { useEffect, useState } from "react";
import {
  Button,
  Breadcrumb,
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  Form,
  Row,
  Stack,
  FormSelect,
  Modal,
} from "react-bootstrap";
import { useLocation, useNavigate } from "react-router-dom";
import { InputGroup } from 'react-bootstrap';
import PubSub from "pubsub-js";
import Select from "react-select";

import { regExPattern } from "../../utils/regExPattern";
import { validationMessages } from "../../utils/messages";
import { ROUTES } from "../../constants/webRouting";
import fuziElevatorsApi from "../../api/fuziElevatorsApi";
import CityState from "../../constants/CityState.json";
import {
  formatDate,
  formatDateForView,
  getUserDetails,
} from "../../utils/helper";
import * as Constant from "../../constants/CONSTANT";
import { handleUppercaseChange } from "../common/UpperCaseMethod";

const WarrantyEdit = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [showLostModal, setShowLostModal] = useState(false);

  const initialErrors = {
    order_id: { message: validationMessages.orderName.required },
    warranty_status: { message: validationMessages.status.required },
    phone: { message: validationMessages.phone.required },
    owner_ids: { message: validationMessages.ownerId.required },
  };

  const userInfo = getUserDetails();
  // console.log("userInfo", userInfo);
  const initialValues = {
    owner_ids: [{ value: userInfo?.id, label: userInfo?.username }],
    is_gst: "Yes",
    city: "Jaipur",
    qty: 1,
  };
  // Handle City & state values
  const [states, setStates] = useState([
    ...new Set(CityState.map((item) => item.state)),
  ]);

  const [segmentOptions, setSegmentOptions] = useState(Constant?.SegmentOptions);//Added by shahir hussain for segment type field 02-02-2025

  //Imran Added 21-01-2026
  const [warranty, setWarranty] = useState({
    ...initialValues,
    ...(location.state || {}),
    qty: location.state?.qty ?? 1,
  });

  const [lostWarrantyData, setLostWarrantyData] = useState({
    lost_date: warranty?.lost_date || new Date(),
    lost_remark: "",
    lost_by_reason: "",
  });

  // Modal control
  const [show, setShow] = useState(false);
  const handleLostWarrantyChange = (e) => {
    const { name, value } = e.target;

    setLostWarrantyData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleLostWarrantySave = () => {
    setWarranty((prev) => ({
      ...prev,
      lost_date: prev?.lost_date || new Date(),
      lost_remark: lostWarrantyData.lost_remark,
      lost_by_reason: lostWarrantyData.lost_by_reason,
    }));

    handleClose();
  };

  const handleClose = () => {
    setLostWarrantyData({
      //lost_date: null,
      lost_remark: "",
      lost_by_reason: "",
    });

    setShow(false);
  };
  //End here Imran Khan
  const handleShow = () => setShow(true);

  const [errors, setErrors] = useState(!location.state ? initialErrors : {});
  useEffect(() => {
    console.log("errors", errors);
  }, [errors]);

  // validation state
  const [validated, setValidated] = useState(false);

  // offer state
  const [orders, setOrders] = useState([]);
  // lead state
  const [leads, setLeads] = useState([]);
  // assign users state
  const [assignUsers, setAssignUsers] = useState([]);

  useEffect(() => {
    async function init() {
      const fetchedOrders = await fuziElevatorsApi.fetchOrdersForWarranty();
      console.log("fetchedOrders", fetchedOrders);
      Array.isArray(fetchedOrders) &&
        setOrders(
          fetchedOrders?.map((fetchedOrder) => ({
            id: fetchedOrder?.id,
            name: `${fetchedOrder?.offer_name_label || ""}`,
            orderData: fetchedOrder,
          })),
        );

      const fetchedLeads = await fuziElevatorsApi.fetchLeads();
      // console.log("fetchedLeads", fetchedLeads);
      Array.isArray(fetchedLeads) &&
        setLeads(
          fetchedLeads?.map((fetchedLead) => ({
            id: fetchedLead?.id,
            name: `${fetchedLead?.lead_name || ""}`,
          })),
        );

      const resultedUsers = await fuziElevatorsApi.fetchUsers();
      resultedUsers &&
        Array.isArray(resultedUsers) &&
        setAssignUsers(resultedUsers);
    }
    init();
  }, []);

  const setLeadDataInFields = async (lead_id) => {
    console.log("value 2 == ", lead_id);
    const leadData = await fuziElevatorsApi.fetchLeadById(lead_id);
    console.log("leadData == ", leadData);
    const warrantyRecord = {};
    // Lead Info
    warrantyRecord.date_of_birth = leadData.date_of_birth || null;
    warrantyRecord.anniversary_date = leadData.anniversary_date || "";
    warrantyRecord.lead_type = leadData.leadtype || "";
    warrantyRecord.qty = leadData.qty || "";
    setWarranty((prev) => ({ ...prev, ...warrantyRecord }));
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    // console.log(e.target);
    if (name === "order_id") {
      if (value === "") {
        setErrors((prev) => ({
          ...prev,
          [name]: { message: validationMessages.orderName.required },
        }));
      } else {
        setErrors((prev) => {
          delete prev[name];
          return { ...prev };
        });
      }
    }

    // Imran khan Update Enquiry Lost Modal Code Here 07-01-2026
    if (name === "warranty_status" && value === "Warranty Lost") {
      setWarranty((pre) => ({ ...pre, lost_date: new Date() }));
      handleShow();
      setValidated(true);
      setWarranty((prev) => ({ ...prev, [name]: value }));
    }
    //end Imran khan Update Enquiry Lost Modal Code Here 07-01-2026

    if (name === "warranty_status") {
      if (value === "") {
        setErrors((prev) => ({
          ...prev,
          [name]: { message: validationMessages.status.required },
        }));
      } else {
        setErrors((prev) => {
          delete prev[name];
          return { ...prev };
        });
      }

      // if status is lost, then set is_lost to true
      if (value == "warranty_status") {
        setWarranty((prev) => ({
          ...prev,
          is_lost: true,
          lost_date: new Date(),
        }));
        setShowLostModal(true);
      }
    } else if (name == "email") {
      if (
        value != "" &&
        e?.target?.pattern &&
        !RegExp(e.target.pattern).test(value)
      ) {
        setErrors((prev) => ({
          ...prev,
          [name]: { message: validationMessages.email.invalid },
        }));
      } else {
        setErrors((prev) => {
          delete prev[name];
          return { ...prev };
        });
      }
    } else if (name === "phone") {
      if (value === "") {
        setErrors((prev) => ({
          ...prev,
          [name]: { message: validationMessages.phone.required },
        }));
      } else if (e?.target?.pattern && !RegExp(e.target.pattern).test(value)) {
        setErrors((prev) => ({
          ...prev,
          [name]: { message: validationMessages.phone.invalid },
        }));
      } else {
        setErrors((prev) => {
          delete prev[name];
          return { ...prev };
        });
      }
    } else if (name == "whatsapp_no") {
      if (
        value != "" &&
        e?.target?.pattern &&
        !RegExp(e.target.pattern).test(value)
      ) {
        setErrors((prev) => ({
          ...prev,
          [name]: { message: validationMessages.whatsappNumber.invalid },
        }));
      } else {
        setErrors((prev) => {
          delete prev[name];
          return { ...prev };
        });
      }
    } else if (name == "warranty_start_date") {
      if (warranty.warranty_service_frequency != "" && !value) {
        setErrors((prev) => ({
          ...prev,
          [name]: { message: validationMessages.warrantStartDate.required },
        }));
      } else {
        setErrors((prev) => {
          delete prev[name];
          return { ...prev };
        });
      }
    } else if (name == "warranty_end_date") {
      if (warranty.warranty_service_frequency != "" && !value) {
        setErrors((prev) => ({
          ...prev,
          [name]: { message: validationMessages.warrantEndDate.required },
        }));
      } else {
        setErrors((prev) => {
          delete prev[name];
          return { ...prev };
        });
      }
    } else if (name == "owner_ids") {
      if (!value?.length) {
        setErrors((prev) => ({
          ...prev,
          [name]: { message: validationMessages.ownerId.required },
        }));
      } else {
        setErrors((prev) => {
          delete prev[name];
          return { ...prev };
        });
      }
    } else if (name == "pincode") {
      if (
        value != "" &&
        e?.target?.pattern &&
        !RegExp(e.target.pattern).test(value)
      ) {
        setErrors((prev) => ({
          ...prev,
          [name]: { message: validationMessages.pinCode.invalid },
        }));
      } else {
        setErrors((prev) => {
          delete prev[name];
          return { ...prev };
        });
      }
    } else if (name === "segment") {//Added by shahir hussain for segment type field 02-02-2025
      const values = Array.isArray(value)
        ? value?.map((item) => item?.value)
        : [];

      const segmentString = values.join(",");

      setWarranty((prev) => ({
        ...prev,
        segment: segmentString,
      }));

      // validation
      // if (values?.length === 0) {
      //   setErrors((prev) => ({
      //     ...prev,
      //     segment: { message: validationMessages.segment.required },
      //   }));
      // } else {
      //   setErrors((prev) => {
      //     delete prev.segment;
      //     return { ...prev };
      //   });
      // }

      setValidated(true);
      return;
    }

    //Add this condition by shahir hussain for get lead data by id 27-08-2025
    if (name == "lead_id") {
      console.log("value == ", value);
      setValidated(true);
      setWarranty((prev) => ({ ...prev, [name]: value }));
      setLeadDataInFields(value);
    } else {
      setValidated(true);
      setWarranty((prev) => ({ ...prev, [name]: value }));
    }
  };
  // field validators
  const checkRequiredFields = () => {
    let isError = false;

    if (warranty?.order_id) {
      if (warranty?.order_id == "") {
        setErrors((prev) => ({
          ...prev,
          order_id: { message: validationMessages.orderName.required },
        }));
        isError = true;
      } else {
        setErrors((prev) => {
          delete prev["order_id"];
          return { ...prev };
        });
      }
    }

    if (warranty?.warranty_status) {
      if (warranty?.warranty_status == "") {
        setErrors((prev) => ({
          ...prev,
          warranty_status: { message: validationMessages.status.required },
        }));
        isError = true;
      } else {
        setErrors((prev) => {
          delete prev["warranty_status"];
          return { ...prev };
        });
      }
    }

    if (warranty?.email) {
      if (
        warranty?.email != "" &&
        regExPattern?.email &&
        !RegExp(regExPattern.email).test(warranty.email)
      ) {
        setErrors((prev) => ({
          ...prev,
          email: { message: validationMessages.email.invalid },
        }));
        isError = true;
      } else {
        setErrors((prev) => {
          delete prev["email"];
          return { ...prev };
        });
      }
    }

    if (warranty?.phone) {
      if (warranty?.phone == "") {
        setErrors((prev) => ({
          ...prev,
          phone: { message: "Please provide phone." },
        }));
        isError = true;
      } else if (
        regExPattern?.phone &&
        !RegExp(regExPattern.phone).test(warranty.phone)
      ) {
        setErrors((prev) => ({
          ...prev,
          phone: { message: "Please provide Valid phone." },
        }));
        isError = true;
      } else {
        setErrors((prev) => {
          delete prev["phone"];
          return { ...prev };
        });
      }
    }

    if (warranty?.whatsapp_no) {
      if (
        warranty?.whatsapp_no != "" &&
        regExPattern?.phone &&
        !RegExp(regExPattern.phone).test(warranty.whatsapp_no)
      ) {
        setErrors((prev) => ({
          ...prev,
          whatsapp_no: { message: "Please provide Valid whatsapp number." },
        }));
        isError = true;
      } else {
        setErrors((prev) => {
          delete prev["whatsapp_no"];
          return { ...prev };
        });
      }
    }
    if (warranty.warranty_service_frequency) {
      if (!warranty?.warranty_start_date) {
        setErrors((prev) => ({
          ...prev,
          warranty_start_date: {
            message: validationMessages.warrantStartDate.required,
          },
        }));
        isError = true;
      }
      if (!warranty?.warranty_end_date) {
        setErrors((prev) => ({
          ...prev,
          warranty_end_date: {
            message: validationMessages.warrantEndDate.required,
          },
        }));
        isError = true;
      }
    }
    // if (warranty?.warranty_start_date) {
    //     if (warranty.warranty_upto  && (!warranty?.warranty_start_date)) {
    //         setErrors((prev) => ({ ...prev, 'warranty_start_date': { message: validationMessages.warrantStartDate.required } }));
    //     } else {
    //         setErrors((prev) => {
    //             delete prev['warranty_start_date'];
    //             return { ...prev };
    //         });
    //     }
    // }

    // if (warranty?.warranty_end_date) {
    //     if (warranty.warranty_upto  && (!warranty?.warranty_end_date)) {
    //         setErrors((prev) => ({ ...prev, 'warranty_end_date': { message: validationMessages.warrantEndDate.required } }));
    //     } else {
    //         setErrors((prev) => {
    //             delete prev['warranty_end_date'];
    //             return { ...prev };
    //         });
    //     }
    // }

    if (warranty?.owner_ids) {
      if (!warranty?.owner_ids?.length) {
        setErrors((prev) => ({
          ...prev,
          owner_ids: { message: validationMessages.ownerId.required },
        }));
        isError = true;
      } else {
        setErrors((prev) => {
          delete prev["owner_ids"];
          return { ...prev };
        });
      }
    }

    if (warranty?.pincode) {
      if (
        warranty?.pincode != "" &&
        regExPattern?.pinCode &&
        !RegExp(regExPattern.pinCode).test(warranty.pincode)
      ) {
        setErrors((prev) => ({
          ...prev,
          pincode: { message: "Please provide valid pincode." },
        }));
        isError = true;
      } else {
        setErrors((prev) => {
          delete prev["pincode"];
          return { ...prev };
        });
      }
    }

    // handle errors for required fields
    if (!warranty?.order_id) {
      setErrors((prev) => ({
        ...prev,
        order_id: { message: validationMessages.orderName.required },
      }));
      isError = true;
    }
    if (!warranty?.warranty_status) {
      setErrors((prev) => ({
        ...prev,
        warranty_status: { message: validationMessages.status.required },
      }));
      isError = true;
    }
    if (!warranty?.owner_ids?.length) {
      setErrors((prev) => ({
        ...prev,
        owner_ids: { message: validationMessages.ownerId.required },
      }));
      isError = true;
    }
    if (!warranty?.phone) {
      setErrors((prev) => ({
        ...prev,
        phone: { message: validationMessages.phone.required },
      }));
      isError = true;
    }

    return isError;
  };

  // onSubmit handler
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (checkRequiredFields()) {
      setValidated(true);
      return;
    }
    if (Object?.keys(errors)?.length != 0) {
      setValidated(true);
      return;
    }
    const record = { ...warranty };

    //Added Imran Khan on 18 feb 2026
    // Check if warranty already exists for this order (only for new records)
    if (!record.id && record.order_id) {
      const warrantyCheck = await fuziElevatorsApi.checkWarrantyExists(
        record.order_id,
      );

      if (warrantyCheck?.exists) {
        PubSub.publish("RECORD_ERROR_TOAST", {
          title: "Warranty Already Exists",
          message: "A warranty record already exists for this order.",
        });
        return;
      }
    }

    // delete unnecessary fields
    delete record.owner_name;
    delete record.lead_name;
    delete record.offer_name_label;

    // Handle date formate
    if (record?.date_of_birth)
      record.date_of_birth = formatDate(record.date_of_birth);
    if (record?.anniversary_date)
      record.anniversary_date = formatDate(record.anniversary_date);
    if (record?.warranty_start_date)
      record.warranty_start_date = formatDate(record.warranty_start_date);
    if (record?.warranty_end_date)
      record.warranty_end_date = formatDate(record.warranty_end_date);
    if (record?.lost_date) record.lost_date = formatDate(record.lost_date);

    // Handle numeric fields
    record.passenger_capacity = record?.passenger_capacity || null;
    record.total_stops = record?.total_stops || null;

    // Handle date fields
    record.date_of_birth = record.date_of_birth ? record.date_of_birth : null;
    record.anniversary_date = record.anniversary_date
      ? record.anniversary_date
      : null;
    record.warranty_start_date = record.warranty_start_date
      ? record.warranty_start_date
      : null;
    record.warranty_end_date = record.warranty_end_date
      ? record.warranty_end_date
      : null;
    record.lost_date = record.lost_date ? record.lost_date : null;

    // handel owner_ids
    record.owner_ids = record.owner_ids
      ?.filter((item) => item.value)
      ?.map((item) => item.value);
    // //========= Logic to perform Create or Edit ======
    if (record.id) {
      // console.log('Updated');
      const result = await fuziElevatorsApi.saveWarranty(record);
      if (result?.success) {
        PubSub.publish("RECORD_SAVED_TOAST", {
          title: "Record Update",
          message: "Record updated successfully",
        });
        // navigate(`/contacts/${record?.id}`, { state: record });
        navigate(`${ROUTES.WARRANTY.LIST}/${record?.id}`, { state: record });
      } else {
        PubSub.publish("RECORD_ERROR_TOAST", {
          title: "Record Update Error",
          message: result?.errors,
        });
      }
    } else {
      //Imran Khan AMC Ticket 1062- added this condition to check if warranty is running or not
      const result = await fuziElevatorsApi.createWarranty(record);
      if (result?.success) {
        if (record?.order_id) {
          await fuziElevatorsApi.saveOrder({
            id: record.order_id,
            order_status: "Warranty Running",
          });
        }
        PubSub.publish("RECORD_SAVED_TOAST", {
          title: "Record created",
          message: "Record created successfully",
        });
        navigate(`${ROUTES.WARRANTY.LIST}/${result.id}`, {
          state: result.data,
        });
      } else {
        PubSub.publish("RECORD_ERROR_TOAST", {
          title: "Record Save Error",
          message: result?.errors,
        });
      }
    }
  };

  const handleCancel = () => {
    if (warranty.id) {
      navigate(`${ROUTES.WARRANTY.LIST}/${warranty.id}`, { state: warranty });
    } else {
      navigate(ROUTES.WARRANTY.LIST);
    }
  };
  //Imran Khan 15/01/2026
  useEffect(() => {
    if (location?.state?.order_id) {
      onOrderSelect(location?.state?.order_id);
    }
  }, [location?.state?.order_id]);
  //End here

  const onOrderSelect = async (id) => {
    const orderData = await fuziElevatorsApi.fetchOrderById(id);
    console.log("orderData", orderData);
    if (orderData) {
      const warrantyRecord = {};
      // General Info
      warrantyRecord.lead_id = orderData.lead_id || null;
      warrantyRecord.lead_name = orderData.lead_name || "";

      warrantyRecord.email = orderData.email || "";
      warrantyRecord.phone = orderData.phone || "";
      warrantyRecord.whatsapp_no = orderData.whatsapp_no || "";
      warrantyRecord.owner_ids = orderData.owner_ids || [];
      warrantyRecord.owner_name = orderData.owner_name || "";

      // Customer Info
      warrantyRecord.customer_type = orderData.customer_type || "";
      warrantyRecord.company_name = orderData.company_name || "";
      warrantyRecord.sector = orderData.sector || "";
      warrantyRecord.is_gst = orderData.is_gst || "";
      warrantyRecord.gst_number = orderData.gst_no || "";
      // warrantyRecord.competitor_name = orderData.competitor_name || "";

      // Warranty Info
      warrantyRecord.passenger_capacity = orderData.passenger_capacity || null;
      warrantyRecord.total_stops = orderData.total_stops || null;
      warrantyRecord.same_side = orderData.same_side || "";
      warrantyRecord.motor_make = orderData.motor_make || "";
      warrantyRecord.door_metal = orderData.door_metal || "";
      warrantyRecord.door_make = orderData.door_make || "";
      warrantyRecord.dlp_period = orderData.dlp_period || "";
      warrantyRecord.cabin_metal = orderData.cabin_metal || "";
      warrantyRecord.door_panels = orderData.door_panels || "";

      // Address Info
      warrantyRecord.site_address = orderData.site_address || "";
      warrantyRecord.state = orderData.state || "";
      warrantyRecord.city = orderData.city || "";
      warrantyRecord.office_address = orderData.office_address || "";
      warrantyRecord.office_city = orderData.office_city || "";
      warrantyRecord.pincode = orderData.pincode || "";
      warrantyRecord.country = orderData.country || "";
      warrantyRecord.area = orderData.area || "";
      warrantyRecord.segment = orderData.segment || "";
      warrantyRecord.warranty_start_date = orderData.warranty_start_date || "";
      warrantyRecord.warranty_end_date = orderData.warranty_end_date || "";

      if (orderData.phone) {
        setErrors((prev) => {
          delete prev["phone"];
          return { ...prev };
        });
      }
      if (orderData?.owner_ids) {
        setErrors((prev) => {
          delete prev["owner_ids"];
          return { ...prev };
        });
      }

      setWarranty((prev) => ({ ...prev, ...warrantyRecord }));
    }
  };

  const formatDateForCreatedDate = (dateString) => {
    if (dateString) {
      const date = new Date(dateString);
      return date.toLocaleDateString("en-GB", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
      });
    }
    return "";
  };

  return (
    <Container className="pb-5">
      {/* Imran khan Update Enquiry Lost Modal Code Here 07-01-2026 */}
      <>
        <Modal
          show={show}
          onHide={handleClose}
          backdrop="static"
          keyboard={false}
        >
          <Modal.Header closeButton>
            <Modal.Title>REASON OF LOST WARRANTY</Modal.Title>
          </Modal.Header>

          <Modal.Body>
            <Col lg={12}>
              <Form.Group>
                <Form.Label>Lost Date</Form.Label>
                <Form.Control
                  disabled
                  value={formatDateForCreatedDate(warranty?.lost_date)}
                />
              </Form.Group>
            </Col>

            <Col lg={12} className="mt-2">
              <Form.Group>
                <Form.Label>Warranty Lost Reason</Form.Label>
                <Form.Control
                  type="text"
                  name="lost_remark"
                  placeholder="Lost Remark"
                  value={lostWarrantyData?.lost_remark}
                  onChange={handleLostWarrantyChange}
                />
              </Form.Group>
            </Col>

            <Col lg={12} className="mt-2">
              <Form.Group>
                <Form.Label>Lost By (Company)</Form.Label>
                <Form.Control
                  type="text"
                  name="lost_by_reason"
                  placeholder="Lost by Reason"
                  value={lostWarrantyData?.lost_by_reason}
                  onChange={handleLostWarrantyChange}
                />
              </Form.Group>
            </Col>
          </Modal.Body>

          <Modal.Footer>
            <Button variant="primary" onClick={handleLostWarrantySave}>
              Save
            </Button>
            <Button variant="secondary" onClick={handleClose}>
              Close
            </Button>
          </Modal.Footer>
        </Modal>
      </>
      {/* End Here Imran khan Update Enquiry Lost Modal Code Here 07-01-2026 */}
      <Row>
        <Col md={12} className="sticky-breadcrumb">
          <Breadcrumb>
            <Breadcrumb.Item onClick={() => navigate(ROUTES.HOME)}>
              Home
            </Breadcrumb.Item>
            <Breadcrumb.Item onClick={() => navigate(ROUTES.WARRANTY.LIST)}>
              Warranty
            </Breadcrumb.Item>
          </Breadcrumb>
        </Col>
        <Col md={12}>
          <Form
            className=""
            onSubmit={() => handleSubmit}
            noValidate
            validated={validated}
          >
            <Card className="shadow">
              <CardHeader className="bg-custom text-white sticky-card-header">
                <Row className="w-100">
                  <Col lg={6} className="">
                    <div className="d-flex align-items-center h-100 gap-3">
                      {warranty?.id ? (
                        <h5 className="m-0">
                          Edit Warranty {warranty?.order_jon_no || ""}
                        </h5>
                      ) : (
                        <h5 className="m-0">Create Warrant</h5>
                      )}
                    </div>
                  </Col>
                  <Col lg={6} className="p-0">
                    <Stack direction="horizontal" className="float-end" gap={2}>
                      <Button
                        size="sm"
                        className="btn-save"
                        onClick={handleSubmit}
                      >
                        Save
                      </Button>
                      <Button
                        size="sm"
                        className="btn-delete"
                        onClick={handleCancel}
                      >
                        Cancel
                      </Button>
                    </Stack>
                  </Col>
                </Row>
              </CardHeader>

              <CardBody className="">
                <Row lg={12} className="view-form ">
                  <>
                    <Col lg={6}>
                      <Form.Group>
                        <Form.Label
                          className="form-view-label"
                          htmlFor="formBasicOffer"
                        >
                          Order
                        </Form.Label>
                        <div className="d-flex align-items-center gap-2">
                          <div className="flex-grow-1">
                            <Select
                              required
                              className={`${warranty?.order_id ? "custom-select-valid" : "custom-select-invalid"}`}
                              placeholder="Select your order"
                              options={orders?.map((order) => ({
                                value: order?.id,
                                label: order?.name,
                              }))}
                              onChange={(e) => {
                                handleChange({
                                  target: { name: "order_id", value: e.value },
                                });
                                handleChange({
                                  target: {
                                    name: "offer_name_label",
                                    value: e.label,
                                  },
                                });
                                onOrderSelect(e.value);
                              }}
                              value={
                                warranty?.order_id
                                  ? {
                                      value: warranty?.order_id,
                                      label: warranty?.offer_name_label,
                                    }
                                  : ""
                              }
                            />
                          </div>
                          <Button
                            size="sm"
                            variant="success"
                            disabled={!warranty?.order_id}
                            onClick={() =>
                              warranty?.order_id &&
                              onOrderSelect(warranty?.order_id)
                            }
                            className="refresh-btn"
                          >
                            <i className="fa fa-refresh"></i>
                          </Button>
                        </div>
                        <Form.Control.Feedback type="invalid">
                          {errors?.order_id?.message}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                    <Col lg={6}>
                      <Form.Group>
                        <Form.Label
                          className="form-view-label"
                          htmlFor="formBasicStateLead"
                        >
                          Lead
                        </Form.Label>
                        <Select
                          placeholder="Select your lead"
                          options={leads?.map((lead) => ({
                            value: lead?.id,
                            label: lead?.name,
                          }))}
                          onChange={(e) => {
                            handleChange({
                              target: { name: "lead_id", value: e.value },
                            });
                            handleChange({
                              target: { name: "lead_name", value: e.label },
                            });
                          }}
                          value={
                            warranty?.lead_id
                              ? {
                                  value: warranty?.lead_id,
                                  label: warranty?.lead_name,
                                }
                              : ""
                          }
                        ></Select>
                        <Form.Control.Feedback type="invalid">
                          {errors?.lead_id?.message}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                    <Col lg={6}>
                      <Form.Group>
                        <Form.Label
                          className="form-view-label"
                          htmlFor="formBasicStatus"
                        >
                          Status
                        </Form.Label>
                        <Form.Select
                          required
                          name="warranty_status"
                          value={warranty?.warranty_status || ""}
                          onChange={handleChange}
                        >
                          <option value="">---select status---</option>
                          {Constant.WARRANTY_STATUS_VALUES?.map(
                            (status, index) => (
                              <option value={status.label || ""} key={index}>
                                {status.label || ""}
                              </option>
                            ),
                          )}
                        </Form.Select>

                        <Form.Control.Feedback type="invalid">
                          {errors?.warranty_status?.message}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                    <Col lg={6}>
                      <Form.Group>
                        <Form.Label
                          className="form-view-label"
                          htmlFor="formBasicEmail"
                        >
                          Email
                        </Form.Label>
                        <Form.Control
                          pattern={regExPattern.email}
                          type="email"
                          name="email"
                          placeholder="Enter email"
                          value={warranty?.email || ""}
                          onChange={handleChange}
                        />

                        <Form.Control.Feedback type="invalid">
                          {errors?.email?.message}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                    <Col lg={6}>
                      <Form.Group>
                        <Form.Label
                          className="form-view-label"
                          htmlFor="formBasicPhone"
                        >
                          Phone
                        </Form.Label>
                        <Form.Control
                          required
                          type="text"
                          name="phone"
                          placeholder="Enter phone"
                          value={warranty?.phone || ""}
                          onChange={handleChange}
                          maxLength={10}
                          pattern={regExPattern.phone}
                        />
                        <Form.Control.Feedback type="invalid">
                          {errors?.phone?.message}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                    <Col lg={6}>
                      <Form.Group>
                        <Form.Label
                          className="form-view-label"
                          htmlFor="formBasicPhone"
                        >
                          WhatsApp No.
                        </Form.Label>
                        <Form.Control
                          type="text"
                          name="whatsapp_no"
                          placeholder="Enter whatsApp number"
                          value={warranty?.whatsapp_no || ""}
                          onChange={handleChange}
                          maxLength={10}
                          pattern={regExPattern.phone}
                        />

                        <Form.Control.Feedback type="invalid">
                          {errors?.whatsapp_no?.message}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                    <Col lg={6}>
                      <Form.Group>
                        <Form.Label
                          className="form-view-label"
                          htmlFor="formBasicStartDate"
                        >
                          Date Of Birth
                        </Form.Label>
                        <Form.Control
                          type="date"
                          name="date_of_birth"
                          value={formatDate(warranty.date_of_birth || "")}
                          onChange={handleChange}
                          max={formatDate(new Date())}
                          onKeyDown={(e) => e.preventDefault()}
                        />
                        <Form.Control.Feedback type="invalid">
                          {errors?.date_of_birth?.message}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                    <Col lg={6}>
                      <Form.Group>
                        <Form.Label
                          className="form-view-label"
                          htmlFor="formBasicStartDate"
                        >
                          Anniversary Date
                        </Form.Label>
                        <Form.Control
                          type="date"
                          name="anniversary_date"
                          value={formatDate(warranty.anniversary_date || "")}
                          onChange={handleChange}
                          max={formatDate(new Date())}
                          onKeyDown={(e) => e.preventDefault()}
                        />
                        <Form.Control.Feedback type="invalid">
                          {errors?.anniversary_date?.message}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                    {/* <Col lg={6}>
                                            <Form.Group>
                                                <Form.Label
                                                    className="form-view-label"
                                                    htmlFor="formBasicOwner"
                                                >
                                                    Assign Staff
                                                </Form.Label>
                                                <Select
                                                    required
                                                    name="owner_id"
                                                    className={`${warranty?.owner_id ? 'custom-select-valid' : 'custom-select-invalid'}`}
                                                    onChange={(e) => {
                                                        handleChange({ target: { name: "owner_id", value: e.value } });
                                                        handleChange({ target: { name: "owner_name", value: e.label } });
                                                    }}
                                                    options={assignUsers?.map((item) => ({ value: item.id, label: item.username }))}
                                                    value={warranty?.owner_id ? { value: warranty?.owner_id || "", label: warranty?.owner_name || "" } : ""}
                                                />
                                                {(errors?.owner_id?.message && (!warranty.owner_id)) && <div className="feedback-invalid">
                                                    {errors?.owner_id?.message}
                                                </div>}
                                            </Form.Group>
                                        </Col> */}

                    <Col lg={6}>
                      <Form.Group>
                        <Form.Label
                          className="form-view-label"
                          htmlFor="formBasicLeadDelegatedUsers"
                        >
                          Assign Users
                        </Form.Label>
                        <Select
                          isMulti
                          className={`${Array.isArray(warranty?.owner_ids) && warranty?.owner_ids?.length > 0 ? "custom-select-valid" : "custom-select-invalid"}`}
                          placeholder="Select your Assign Staff"
                          options={assignUsers?.map((item) => ({
                            value: item.id,
                            label: item.username,
                          }))}
                          value={warranty?.owner_ids?.filter(
                            (item) => item.value,
                          )}
                          onChange={(e) => {
                            handleChange({
                              target: { name: "owner_ids", value: e },
                            });
                          }}
                        />
                        {errors?.owner_ids?.message && validated && (
                          <div className="feedback-invalid">
                            {errors?.owner_ids?.message}
                          </div>
                        )}
                      </Form.Group>
                    </Col>
                  </>

                  <>
                    <Col md={12} className="section-header">
                      Customer Information
                    </Col>
                    <Col lg={6}>
                      <Form.Group>
                        <Form.Label
                          className="form-view-label"
                          htmlFor="formBasicCustomerType"
                        >
                          Customer Type
                        </Form.Label>
                        <FormSelect
                          name="customer_type"
                          value={warranty?.customer_type || ""}
                          onChange={handleChange}
                        >
                          <option value={""}>--select type--</option>
                          <option value={"Individual"}>Individual</option>
                          <option value={"Corporate"}>Corporate</option>
                        </FormSelect>
                        <Form.Control.Feedback type="invalid">
                          {errors?.customer_type?.message}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                    {warranty?.customer_type == "Corporate" && (
                      <Col lg={6}>
                        <Form.Group>
                          <Form.Label>Company Name</Form.Label>
                          <Form.Control
                            type="text"
                            placeholder="Enter company name"
                            name="company_name"
                            value={warranty?.company_name || ""}
                            onChange={handleChange}
                          />
                        </Form.Group>
                      </Col>
                    )}
                    <Col lg={6}>
                      <Form.Group>
                        <Form.Label
                          className="form-view-label"
                          htmlFor="formBasicSector "
                        >
                          Sector
                        </Form.Label>
                        <Form.Select
                          name="sector"
                          value={warranty?.sector || ""}
                          onChange={handleChange}
                        >
                          <option value="">---select sector---</option>
                          {[
                            "Government site",
                            "Customer is private",
                            "Government customer direct with us",
                          ].map((item, index) => (
                            <option value={item} key={index}>
                              {item}
                            </option>
                          ))}
                        </Form.Select>

                        <Form.Control.Feedback type="invalid">
                          {errors?.sector?.message}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                    <Col lg={6}>
                      <Form.Group>
                        <Form.Label
                          className="form-view-label"
                          htmlFor="formBasicIsGst"
                        >
                          Is GST Applicable
                        </Form.Label>
                        <FormSelect
                          name="is_gst"
                          value={warranty?.is_gst || ""}
                          onChange={handleChange}
                        >
                          <option value={""}>--select--</option>
                          <option value={"Yes"}>Yes</option>
                          <option value={"No"}>No</option>
                        </FormSelect>
                        <Form.Control.Feedback type="invalid">
                          {errors?.is_gst?.message}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                    {warranty?.is_gst === "Yes" && (
                      <Col lg={6}>
                        <Form.Group>
                          <Form.Label>GST Number</Form.Label>
                          <Form.Control
                            type="text"
                            placeholder="Enter gst number"
                            name="gst_number"
                            value={warranty?.gst_number || ""}
                            // onChange={handleChange}
                            onChange={(e) => {
                              const value = e.target.value;
                              setWarranty((prev) => ({
                                ...prev,
                                gst_number: value
                                  .replace(/\s+/g, "")
                                  .toUpperCase(),
                              }));
                            }}
                          />
                        </Form.Group>
                        <Form.Control.Feedback type="invalid">
                          {errors?.gst_number?.message}
                        </Form.Control.Feedback>
                      </Col>
                    )}
                    <Col lg={6}>
                      <Form.Group>
                        <Form.Label>Gst Billing Name</Form.Label>
                        <Form.Control
                          type="text"
                          placeholder="Enter Gst Billing Name"
                          name="gst_billing_name"
                          value={warranty?.gst_billing_name || ""}
                          onChange={handleChange}
                        />
                      </Form.Group>
                      <Form.Control.Feedback type="invalid">
                        {errors?.gst_billing_name?.message}
                      </Form.Control.Feedback>
                    </Col>
                    {/* //Added by shahir hussain for segment type field 02-02-2025 */}
                    <Col lg={6}>
                      <Form.Group>
                        <Form.Label className="form-view-label">
                          Segment Type
                        </Form.Label>

                        <Select
                          isMulti
                          placeholder="Select Segment Type"
                          options={segmentOptions}
                          value={
                            typeof warranty?.segment === "string" &&
                            warranty?.segment
                              ? segmentOptions?.filter((opt) =>
                                  warranty?.segment
                                    ?.split(",")
                                    .includes(opt?.value),
                                )
                              : []
                          }
                          onChange={(selectedOptions) => {
                            handleChange({
                              target: {
                                name: "segment",
                                value: selectedOptions,
                              },
                            });
                          }}
                          // className={
                          //   warranty?.segment && warranty?.segment?.length > 0
                          //     ? "custom-select-valid"
                          //     : "custom-select-invalid"
                          // }
                        />

                        {errors?.segment?.message && validated && (
                          <div className="feedback-invalid">
                            {errors?.segment?.message}
                          </div>
                        )}
                      </Form.Group>
                    </Col>
                  </>

                  <>
                    <Col md={12} className="section-header">
                      Warranty Information
                    </Col>
                    <Col lg={6}>
                      <Form.Group>
                        <Form.Label
                          className="form-view-label"
                          htmlFor="formBasicCompanyName"
                        >
                          Lead Type
                        </Form.Label>
                        <Form.Control
                          type="text"
                          name="lead_type"
                          placeholder="Enter Lead Type"
                          value={warranty?.lead_type || ""}
                          // onChange={handleChange}
                          onChange={(e) =>
                            handleUppercaseChange(e, handleChange)
                          }
                        />
                        <Form.Control.Feedback type="invalid">
                          {errors?.lead_type?.message}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                    <Col lg={6}>
                      <Form.Group>
                        <Form.Label
                          className="form-view-label"
                          htmlFor="formBasicSiteAddress"
                        >
                          Quantity
                        </Form.Label>
                        <Form.Control
                          type="text"
                          value={warranty?.qty}
                          disabled
                        />
                        <Form.Control.Feedback type="invalid">
                          {errors?.qty?.message}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                    <Col lg={6}>
                      <Form.Group>
                        <Form.Label
                          className="form-view-label"
                          htmlFor="formBasicWarrantyUpto"
                        >
                          Warranty Period
                        </Form.Label>
                        <Form.Control
                          type="text"
                          name="warranty_upto"
                          placeholder="Enter warranty Period"
                          value={warranty?.warranty_upto || ""}
                          // onChange={handleChange}
                          onChange={(e) =>
                            handleUppercaseChange(e, handleChange)
                          }
                        />
                        <Form.Control.Feedback type="invalid">
                          {errors?.warranty_upto?.message}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                    <Col lg={6}>
                      <Form.Group>
                        <Form.Label
                          className="form-view-label"
                          htmlFor="formBasicWarrantyServiceFrequency"
                        >
                          Warranty Service Frequency
                        </Form.Label>
                        <FormSelect
                          name="warranty_service_frequency"
                          value={warranty?.warranty_service_frequency || ""}
                          onChange={handleChange}
                        >
                          <option value={""}>--select--</option>
                          <option value={"Monthly"}>Monthly</option>
                          <option value={"Bimonthly"}>Bimonthly</option>
                          <option value={"Quaterly Service"}>
                            Quaterly Service
                          </option>
                        </FormSelect>
                        <Form.Control.Feedback type="invalid">
                          {errors?.warranty_service_frequency?.message}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                    {warranty?.warranty_service_frequency && (
                      <>
                        <Col lg={3}>
                          <Form.Group>
                            <Form.Label
                              className="form-view-label"
                              htmlFor="formBasicWarrantyStartDate"
                            >
                              Warranty Start Date
                            </Form.Label>
                            <Form.Control
                              required
                              type="date"
                              name="warranty_start_date"
                              value={formatDate(
                                warranty?.warranty_start_date || "",
                              )}
                              onChange={(e) => {
                                warranty.warranty_end_date = "";
                                handleChange(e);
                              }}
                            />
                            <Form.Control.Feedback type="invalid">
                              {errors?.warranty_start_date?.message}
                            </Form.Control.Feedback>
                          </Form.Group>
                        </Col>

                        <Col lg={3}>
                          <Form.Group>
                            <Form.Label
                              className="form-view-label"
                              htmlFor="formBasicWarrantyUpto"
                            >
                              warranty Upto
                            </Form.Label>
                            <Form.Control
                              required
                              disabled={!warranty?.warranty_start_date}
                              type="date"
                              name="warranty_end_date"
                              min={formatDate(
                                warranty.warranty_start_date || "",
                              )}
                              value={formatDate(
                                warranty.warranty_end_date || "",
                              )}
                              onChange={handleChange}
                            />
                            <Form.Control.Feedback type="invalid">
                              {errors?.warranty_end_date?.message}
                            </Form.Control.Feedback>
                          </Form.Group>
                        </Col>
                      </>
                    )}
                    <Col lg={6}>
                      <Form.Group>
                        <Form.Label
                          className="form-view-label"
                          htmlFor="formBasicCompanyName"
                        >
                          Building Location
                        </Form.Label>
                        <Form.Control
                          type="text"
                          name="building_location"
                          placeholder="Enter Building Location"
                          value={warranty?.building_location || ""}
                          // onChange={handleChange}
                          onChange={(e) =>
                            handleUppercaseChange(e, handleChange)
                          }
                        />
                        <Form.Control.Feedback type="invalid">
                          {errors?.building_location?.message}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                    <Col lg={6}>
                      <Form.Group>
                        <Form.Label
                          className="form-view-label"
                          htmlFor="formBasicCompanyName"
                        >
                          Cabin Metal
                        </Form.Label>
                        <Form.Control
                          type="text"
                          name="cabin_metal"
                          placeholder="Enter Cabin Metal"
                          value={warranty?.cabin_metal || ""}
                          // onChange={handleChange}
                          onChange={(e) =>
                            handleUppercaseChange(e, handleChange)
                          }
                        />
                        <Form.Control.Feedback type="invalid">
                          {errors?.cabin_metal?.message}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                    <Col lg={6}>
                      <Form.Group>
                        <Form.Label
                          className="form-view-label"
                          htmlFor="formBasicCompanyName"
                        >
                          Door Side
                        </Form.Label>
                        <Form.Control
                          type="text"
                          name="door_side"
                          placeholder="Enter Door Side"
                          value={warranty?.door_side || ""}
                          // onChange={handleChange}
                          onChange={(e) =>
                            handleUppercaseChange(e, handleChange)
                          }
                        />
                        <Form.Control.Feedback type="invalid">
                          {errors?.door_side?.message}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                    <Col lg={6}>
                      <Form.Group>
                        <Form.Label
                          className="form-view-label"
                          htmlFor="formBasicCompanyName"
                        >
                          Door Panels
                        </Form.Label>
                        <Form.Control
                          type="text"
                          name="door_panels"
                          placeholder="Enter Door Panels"
                          value={warranty?.door_panels || ""}
                          onChange={handleChange}
                        />
                        <Form.Control.Feedback type="invalid">
                          {errors?.door_panels?.message}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                    <Col lg={6}>
                      <Form.Group>
                        <Form.Label
                          className="form-view-label"
                          htmlFor="formBasicCompanyName"
                        >
                          Same Side
                        </Form.Label>
                        <Form.Control
                          type="text"
                          name="same_side"
                          placeholder="Enter Same Side"
                          value={warranty?.same_side || ""}
                          // onChange={handleChange}
                          onChange={(e) =>
                            handleUppercaseChange(e, handleChange)
                          }
                        />
                        <Form.Control.Feedback type="invalid">
                          {errors?.same_side?.message}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                    <Col lg={6}>
                      <Form.Group>
                        <Form.Label
                          className="form-view-label"
                          htmlFor="formBasicCompanyName"
                        >
                          Door Metal
                        </Form.Label>
                        <Form.Control
                          type="text"
                          name="door_metal"
                          placeholder="Enter Door Metal"
                          value={warranty?.door_metal || ""}
                          // onChange={handleChange}
                          onChange={(e) =>
                            handleUppercaseChange(e, handleChange)
                          }
                        />
                        <Form.Control.Feedback type="invalid">
                          {errors?.door_metal?.message}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                    <Col lg={6}>
                      <Form.Group>
                        <Form.Label
                          className="form-view-label"
                          htmlFor="formBasicCompanyName"
                        >
                          Door Type
                        </Form.Label>
                        <Form.Control
                          type="text"
                          name="door_type"
                          placeholder="Enter Door Type"
                          value={warranty?.door_type || ""}
                          // onChange={handleChange}
                          onChange={(e) =>
                            handleUppercaseChange(e, handleChange)
                          }
                        />
                        <Form.Control.Feedback type="invalid">
                          {errors?.door_type?.message}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                    <Col lg={6}>
                      <Form.Group>
                        <Form.Label
                          className="form-view-label"
                          htmlFor="formBasicCompanyName"
                        >
                          Door Make
                        </Form.Label>
                        <Form.Control
                          type="text"
                          name="door_make"
                          placeholder="Enter Door Make"
                          value={warranty?.door_make || ""}
                          // onChange={handleChange}
                          onChange={(e) =>
                            handleUppercaseChange(e, handleChange)
                          }
                        />
                        <Form.Control.Feedback type="invalid">
                          {errors?.door_make?.message}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                    <Col lg={6}>
                      <Form.Group>
                        <Form.Label
                          className="form-view-label"
                          htmlFor="formBasicCompanyName"
                        >
                          Is Geared
                        </Form.Label>
                        <Form.Control
                          type="text"
                          name="is_geared"
                          placeholder="Enter Is Geared"
                          value={warranty?.is_geared || ""}
                          // onChange={handleChange}
                          onChange={(e) =>
                            handleUppercaseChange(e, handleChange)
                          }
                        />
                        <Form.Control.Feedback type="invalid">
                          {errors?.is_geared?.message}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                    <Col lg={6}>
                      <Form.Group>
                        <Form.Label
                          className="form-view-label"
                          htmlFor="formBasicCompanyName"
                        >
                          Dlp Period
                        </Form.Label>
                        <Form.Control
                          type="text"
                          name="dlp_period"
                          placeholder="Enter Dlp Period"
                          value={warranty?.dlp_period || ""}
                          // onChange={handleChange}
                          onChange={(e) =>
                            handleUppercaseChange(e, handleChange)
                          }
                        />
                        <Form.Control.Feedback type="invalid">
                          {errors?.dlp_period?.message}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                    <Col lg={6}>
                      <Form.Group>
                        <Form.Label
                          className="form-view-label"
                          htmlFor="formBasicCompanyName"
                        >
                          Motor Make
                        </Form.Label>
                        <Form.Control
                          type="text"
                          name="motor_make"
                          placeholder="Enter Motor Make"
                          value={warranty?.motor_make || ""}
                          // onChange={handleChange}
                          onChange={(e) =>
                            handleUppercaseChange(e, handleChange)
                          }
                        />
                        <Form.Control.Feedback type="invalid">
                          {errors?.motor_make?.message}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                    <Col lg={6}>
                      <Form.Group>
                        <Form.Label
                          className="form-view-label"
                          htmlFor="formBasicCompanyName"
                        >
                          Control Panel Make
                        </Form.Label>
                        <Form.Control
                          type="text"
                          name="control_panel_make"
                          placeholder="Enter Control Panel Make"
                          value={warranty?.control_panel_make || ""}
                          // onChange={handleChange}
                          onChange={(e) =>
                            handleUppercaseChange(e, handleChange)
                          }
                        />
                        <Form.Control.Feedback type="invalid">
                          {errors?.control_panel_make?.message}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                    <Col lg={6}>
                      <Form.Group>
                        <Form.Label
                          className="form-view-label"
                          htmlFor="formBasicCompanyName"
                        >
                          Control Panel Detail
                        </Form.Label>
                        <Form.Control
                          type="text"
                          name="control_panel_detail"
                          placeholder="Enter Control Panel Detail"
                          value={warranty?.control_panel_detail || ""}
                          // onChange={handleChange}
                          onChange={(e) =>
                            handleUppercaseChange(e, handleChange)
                          }
                        />
                        <Form.Control.Feedback type="invalid">
                          {errors?.control_panel_detail?.message}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                    <Col lg={6}>
                      <Form.Group>
                        <Form.Label
                          className="form-view-label"
                          htmlFor="formBasicCompanyName"
                        >
                          Ard Make
                        </Form.Label>
                        <Form.Control
                          type="text"
                          name="ard_make"
                          placeholder="Enter Ard Make"
                          value={warranty?.ard_make || ""}
                          // onChange={handleChange}
                          onChange={(e) =>
                            handleUppercaseChange(e, handleChange)
                          }
                        />
                        <Form.Control.Feedback type="invalid">
                          {errors?.ard_make?.message}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                    {/* Kg Added by Imran Khan on 28-02-2026 */}
                    <Col lg={6}>
                      <Form.Group>
                        <Form.Label
                          className="form-view-label"
                          htmlFor="formBasicCompanyName"
                        >
                          Passenger Capacity
                        </Form.Label>
                        <InputGroup>
                          <Form.Control
                            type="number"
                            name="passenger_capacity"
                            placeholder="Enter Passenger Capacity"
                            value={warranty?.passenger_capacity || ""}
                            onChange={handleChange}
                          />
                          <InputGroup.Text>Kg</InputGroup.Text>
                        </InputGroup>
                        <Form.Control.Feedback type="invalid">
                          {errors?.passenger_capacity?.message}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                    <Col lg={6}>
                      <Form.Group>
                        <Form.Label
                          className="form-view-label"
                          htmlFor="formBasicCompanyName"
                        >
                          Total Stops
                        </Form.Label>
                        <Form.Control
                          type="number"
                          name="total_stops"
                          placeholder="Enter Total Stops"
                          value={warranty?.total_stops || ""}
                          onChange={handleChange}
                        />
                        <Form.Control.Feedback type="invalid">
                          {errors?.total_stops?.message}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                  </>

                  <>
                    <Col md={12} className="section-header">
                      Address Information
                    </Col>
                    <Col lg={6}>
                      <Form.Group>
                        <Form.Label
                          className="form-view-label"
                          htmlFor="formBasicSiteAddress"
                        >
                          Site Address
                        </Form.Label>
                        <Form.Control
                          type="text"
                          name="site_address"
                          placeholder="Enter site address"
                          value={warranty?.site_address || ""}
                          // onChange={handleChange}
                          onChange={(e) =>
                            handleUppercaseChange(e, handleChange)
                          }
                        />
                        <Form.Control.Feedback type="invalid">
                          {errors?.site_address?.message}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                    {/* //Added by shahir hussain */}
                    <Col lg={6}>
                      <Form.Group>
                        <Form.Label
                          className="form-view-label"
                          htmlFor="formBasicArea"
                        >
                          Area
                        </Form.Label>
                        <Form.Control
                          pattern={regExPattern.name}
                          type="text"
                          name="area"
                          placeholder="Enter area name"
                          value={warranty?.area || ""}
                          // onChange={handleChange}
                          onChange={(e) =>
                            handleUppercaseChange(e, handleChange)
                          }
                        />
                        <Form.Control.Feedback type="invalid">
                          {errors?.area?.message}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                    <Col lg={6}>
                      <Form.Group>
                        <Form.Label
                          className="form-view-label"
                          htmlFor="formBasicState"
                        >
                          State
                        </Form.Label>

                        <Select
                          placeholder="Select your state"
                          options={states?.map((state) => ({
                            value: state,
                            label: state,
                          }))}
                          onChange={(e) => {
                            setWarranty((prev) => ({ ...prev, city: "" }));
                            handleChange({
                              target: { name: "state", value: e.value },
                            });
                          }}
                          value={
                            warranty?.state
                              ? {
                                  value: warranty?.state || "",
                                  label: warranty?.state || "",
                                }
                              : ""
                          }
                        ></Select>
                        <Form.Control.Feedback type="invalid">
                          {errors?.state?.message}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                    <Col lg={6}>
                      <Form.Group>
                        <Form.Label
                          className="form-view-label"
                          htmlFor="formBasicCity"
                        >
                          City
                        </Form.Label>
                        <Form.Control
                          type="text"
                          name="city"
                          placeholder="Enter city"
                          value={warranty?.city || ""}
                          // onChange={handleChange}
                          onChange={(e) =>
                            handleUppercaseChange(e, handleChange)
                          }
                        />
                        <Form.Control.Feedback type="invalid">
                          {errors?.city?.message}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                    <Col lg={6}>
                      <Form.Group>
                        <Form.Label
                          className="form-view-label"
                          htmlFor="formBasicOfficeAddress"
                        >
                          Office Address
                        </Form.Label>
                        <Form.Control
                          type="text"
                          name="office_address"
                          placeholder="Enter office address"
                          value={warranty?.office_address || ""}
                          // onChange={handleChange}
                          onChange={(e) =>
                            handleUppercaseChange(e, handleChange)
                          }
                        />
                        <Form.Control.Feedback type="invalid">
                          {errors?.office_address?.message}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                    <Col lg={6}>
                      <Form.Group>
                        <Form.Label
                          className="form-view-label"
                          htmlFor="formBasicOfficeCity"
                        >
                          Office City
                        </Form.Label>
                        <Form.Control
                          type="text"
                          name="office_city"
                          placeholder="Enter office city"
                          value={warranty?.office_city || ""}
                          // onChange={handleChange}
                          onChange={(e) =>
                            handleUppercaseChange(e, handleChange)
                          }
                        />
                        <Form.Control.Feedback type="invalid">
                          {errors?.office_city?.message}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                    <Col lg={6}>
                      <Form.Group>
                        <Form.Label
                          className="form-view-label"
                          htmlFor="formBasicPin"
                        >
                          Pincode
                        </Form.Label>
                        <Form.Control
                          type="text"
                          name="pincode"
                          placeholder="Enter pincode"
                          value={warranty?.pincode || ""}
                          onChange={handleChange}
                          pattern={regExPattern.pinCode}
                        />

                        <Form.Control.Feedback type="invalid">
                          {errors?.pincode?.message}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                    <Col lg={6}>
                      <Form.Group>
                        <Form.Label
                          className="form-view-label"
                          htmlFor="formBasicCountry"
                        >
                          Country
                        </Form.Label>
                        <Form.Control
                          type="text"
                          name="country"
                          placeholder="Enter country"
                          value={warranty?.country || ""}
                          // onChange={handleChange}
                          onChange={(e) =>
                            handleUppercaseChange(e, handleChange)
                          }
                          pattern={regExPattern.name}
                        />
                        <Form.Control.Feedback type="invalid">
                          {errors?.country?.message}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                  </>

                  {/* <Col lg={6}>
                                        <Form.Group >
                                            <Form.Label
                                                className="form-view-label"
                                                htmlFor="formBasicWarrantyStatus"
                                            >
                                                Warranty Status
                                            </Form.Label>
                                            <Form.Select
                                                name="warranty_status"
                                                value={warranty?.warranty_status || ""}
                                                onChange={handleChange}
                                            >
                                                <option value="">---select status---</option>
                                                {["Started", "Ended", "Renewal"].map((item, index) => <option value={item} key={index}>{item}</option>)}
                                            </Form.Select>

                                            <Form.Control.Feedback type="invalid">
                                                {errors?.warranty_status?.message}
                                            </Form.Control.Feedback>

                                        </Form.Group>
                                    </Col> */}
                  {/* <Col lg={6}>
                                            <Form.Group >
                                                <Form.Label
                                                    className="form-view-label"
                                                    htmlFor="formBasicCompanyName"
                                                >
                                                    Warranty Upto
                                                </Form.Label>
                                                <Form.Control
                                                    type="text"
                                                    name="warranty_upto"
                                                    placeholder="Enter Warranty Upto"
                                                    value={warranty?.warranty_upto || ""}
                                                    onChange={handleChange}
                                                  
                                                />
                                                <Form.Control.Feedback type="invalid">
                                                    {errors?.warranty_upto?.message}
                                                </Form.Control.Feedback>
                                            </Form.Group>
                                        </Col> */}
                </Row>
              </CardBody>
            </Card>
          </Form>
        </Col>
      </Row>
      <Modal show={showLostModal}>
        <Modal.Header>
          <Modal.Title>REASON OF WARRANTY LOST</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Col lg={12}>
            <Form.Group>
              <Form.Label>Lost Date</Form.Label>
              <Form.Control
                disabled
                value={formatDateForView(warranty.lost_date)}
              />
            </Form.Group>
          </Col>
          <Col lg={12}>
            <Form.Group>
              <Form.Label>Reason</Form.Label>
              <Form.Control
                type="text"
                name="lost_remark"
                placeholder="Enter reason"
                value={warranty?.lost_remark || ""}
                onChange={handleChange}
                // pattern={regExPattern.name}
              />
            </Form.Group>
          </Col>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="success"
            disabled={!warranty?.lost_remark}
            onClick={() => setShowLostModal(false)}
          >
            Done
          </Button>
        </Modal.Footer>
      </Modal>
    </Container>
  );
};

export default WarrantyEdit;
